import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { Controller } from '@hotwired/stimulus';

/* global requestAnimationFrame */

// Connects to data-controller="lookup-filters"
// Toggles the filter panel used by LookupTableComponent.
var _default = /*#__PURE__*/function (_Controller) {
  function _default() {
    _classCallCheck(this, _default);
    return _callSuper(this, _default, arguments);
  }
  _inherits(_default, _Controller);
  return _createClass(_default, [{
    key: "toggle",
    value: function toggle() {
      if (!this.hasPanelTarget) return;
      var hidden = this.panelTarget.classList.toggle('d-none');
      this.updateExpanded(!hidden);
    }
  }, {
    key: "hide",
    value: function hide() {
      if (!this.hasPanelTarget) return;
      this.panelTarget.classList.add('d-none');
      this.updateExpanded(false);
    }
  }, {
    key: "scrollToForm",
    value: function scrollToForm(event) {
      var frame = event.target;
      if (!frame || !this.element.contains(frame) || frame.innerHTML.trim() === '') return;
      requestAnimationFrame(function () {
        frame.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      });
    }
  }, {
    key: "updateExpanded",
    value: function updateExpanded(expanded) {
      if (!this.hasButtonTarget) return;
      this.buttonTarget.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    }
  }]);
}(Controller);
_defineProperty(_default, "targets", ['panel', 'button']);
export { _default as default };